import ZonesController from './zones.controller';

export default {
    template: require('./zones.tpl.html'),
    controller: ZonesController
};
